(function () {
  'use strict';
  angular
    .module('com.module.core')
    .service('ApiService', function ($q, $http, CoreService) {

      this.checkConnection = function () {
        return $q(function (resolve, reject) {
          $http.get(CoreService.env.apiUrl)
            .success(resolve)
            .error(reject);
        });
      };

    });

})();
